import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import './PrivacyPolicyPage.css';

const API_BASE_URL = '/api';

const PrivacyPolicyPage = () => {
  const [loading, setLoading] = useState(true);
  const [pageData, setPageData] = useState({
    title: 'Privacy Policy',
    description: 'Learn how we collect, use, and protect your personal information with full transparency.'
  });
  const [paragraphs, setParagraphs] = useState([]);

  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_BASE_URL}/settings/content/privacy-policy`);
      if (response.ok) {
        const data = await response.json();
        setPageData({
          title: data.title || 'Privacy Policy',
          description: data.description || 'Learn how we collect, use, and protect your personal information with full transparency.'
        });
        
        let content = [];
        try {
          content = JSON.parse(data.content || '[]');
        } catch (e) {
          content = data.content ? [data.content] : [];
        }
        setParagraphs(content);
      }
    } catch (error) {
      console.error('Error fetching privacy policy content:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="privacy-policy-page">
      <Header />
      
      <main className="privacy-policy-content">
        <div className="privacy-policy-container">
          {/* Header Section */}
          <div className="privacy-policy-header">
            <h1 className="privacy-policy-title">{pageData.title}</h1>
            <p className="privacy-policy-subtitle">
              {pageData.description}
            </p>
          </div>

          {/* Content Section */}
          <div className="privacy-policy-body">
            {loading ? (
              <p className="privacy-policy-text">Loading...</p>
            ) : paragraphs.length > 0 ? (
              paragraphs.map((paragraph, index) => (
                <p key={index} className="privacy-policy-text">
                  {paragraph}
                </p>
              ))
            ) : (
              <p className="privacy-policy-text">
                At Conflux, we are dedicated to protecting your privacy and personal information.
              </p>
            )}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;
